import axios from "axios";

import ConnUrls from '../ConnectURL'


const getRestMenu = async (obj) => {
    let dFromF = await axios.get(ConnUrls.ApiUrl + "restMenu", { params: obj });
    return (dFromF.data);
}

const getOnlySections = async (obj) => {
    let dFromF = await axios.get(ConnUrls.ApiUrl + "restMenu/getOnlySections", { params: obj });
    return (dFromF.data);
}

const findProductById = async (obj) => {
    let dFromF = await axios.get(ConnUrls.ApiUrl + "restMenu/findProductById", { params: obj });
    return (dFromF.data);
}

const getSectionsDetails = async (itemsOfSection) => {
    const queryString = encodeURIComponent(JSON.stringify(itemsOfSection)); // Convert array to JSON string and encode it
    let dFromF = await axios.get(ConnUrls.ApiUrl + "restMenu/getSectionsDetails", {
        params: { itemsOfSection: queryString }
    });
    return dFromF.data; // Ensure you return the data from the response
}

export default {
    getRestMenu,
    getOnlySections,
    findProductById,
    getSectionsDetails
    // getMnuByRestId,
    // createRestMnu,
    // removeFromMenus
};